<div
  [class.container]="isVerticalLayout$ | async"
  class="toolbar text-default w-full flex items-center">
  <div class="toolbar__start">
    <button
      (click)="openSidenav()"
      [class.hidden]="gtMd$ | async"
      mat-icon-button
      type="button"
      class="mobile-menu-button"
      [attr.aria-label]="'shared.appToolbar.openNavMenuAriaLabel' | translate">
      <mat-icon svgIcon="mat:menu"></mat-icon>
    </button>

    <a
      [routerLink]="['/']"
      class="toolbar__logo flex items-center"
      [class.hidden]="(gtMd$ | async) && (isHorizontalLayout$ | async)">
      <img
        [alt]="'shared.appToolbar.logoAlt' | translate"
        class="w-9 h-9 object-contain shrink-0 select-none"
        src="assets/img/logo/logo.svg" />
      <h1 class="toolbar__wordmark brand-wordmark text-2xl m-0 select-none">
        Proporio
      </h1>
    </a>

    @if ((isVerticalLayout$ | async) && (isNavbarInToolbar$ | async)) {
      <div
        [class.hidden]="(gtMd$ | async) === null"
        class="toolbar__nav flex-none flex items-center">
        @for (item of navigationItems$ | async; track item) {
          <vex-navigation-item [item]="item"></vex-navigation-item>
        }
      </div>
    }

    <div class="workspace-switcher-slot">
      <vex-toolbar-workspace-switcher></vex-toolbar-workspace-switcher>
    </div>
  </div>

  <span class="toolbar__spacer"></span>

  <div class="toolbar__end">
    <vex-toolbar-extraction-indicator></vex-toolbar-extraction-indicator>

    <app-toolbar-ai-search></app-toolbar-ai-search>

    <vex-environment-indicator></vex-environment-indicator>

    <!-- No language selector once signed in: it lives in Préférences
         (/apps/user-profile/preferences). The auth shell keeps its own. -->

    <vex-toolbar-notifications></vex-toolbar-notifications>

    @if (userVisible$ | async) {
      <vex-toolbar-user></vex-toolbar-user>
    }
  </div>
</div>

@if ((isVerticalLayout$ | async) && (isNavbarBelowToolbar$ | async)) {
  <vex-navigation
  [class.hidden]="(gtMd$ | async) === null"></vex-navigation>
}
